export class AccessDataByEmailInputModel {
  account: AccountModel;
}

export class AccountModel {
  name: string;
  privileges: PrivilegeModel[] = [];
  companyId: string;
}

export class PrivilegeModel {
  name: string;
  constructor(privilegeName: string) {
    this.name = privilegeName;
  }
}
